import {
    DataRecordValue,
    DataRecord,
    getColumnLabel,
    CategoricalColorNamespace,
} from '@superset-ui/core';
import { EChartsCoreOption, BarSeriesOption } from 'echarts';
import { OptionDataValue } from 'echarts/types/src/util/types';
import { defaultTooltip } from 'plugins/plugin-chart-echarts/src/defaults';
import {
    DEFAULT_FORM_DATA as DEFAULT_CHART_FORM_DATA,
    EchartsTPolarBarChartProps,
    EchartsTPolarBarFormData,
    TPolarChartTransformedProps,
} from './types';
import { DEFAULT_LEGEND_FORM_DATA } from '../../../types';
import {
    extractGroupbyLabel,
} from '../../../utils/series';
import { MetricSeriesData, getMetricSeriesData, getSeriesKeys, CONSTANTS } from '../utils';

// basic  
  
export default function transformProps(
    chartProps: EchartsTPolarBarChartProps,
): TPolarChartTransformedProps {
    const { formData, height, hooks, queriesData, width } =
      chartProps;
    const data: DataRecord[] = queriesData[0].data || [];
  
    const {
      groupby,
      metrics,
      combineMetrics,
      colorScheme,
      sliceId,
      showLegend
    }: EchartsTPolarBarFormData = {
      ...DEFAULT_LEGEND_FORM_DATA,
      ...DEFAULT_CHART_FORM_DATA,
      ...formData,
    };
    
    const colorFn = CategoricalColorNamespace.getScale(colorScheme as string);

    const groupbyLabels = Array.isArray(groupby) ? groupby.map(getColumnLabel) : [getColumnLabel(groupby)];
    const keys = data.map(datum =>
      extractGroupbyLabel({ datum, groupby: groupbyLabels, coltypeMapping: {} }),
    );
    const labelMap = data.reduce(
      (acc: Record<string, DataRecordValue[]>, datum) => {
        const label = extractGroupbyLabel({
          datum,
          groupby: groupbyLabels,
          coltypeMapping: {},
        });
        return {
          ...acc,
          [label]: groupbyLabels.map(col => datum[col]),
        };
      },
      {},
    );
  
    const { setDataMask = () => {} } = hooks;
  
    const multiMetricData: MetricSeriesData = getMetricSeriesData(metrics || [], data, combineMetrics);

    const series: BarSeriesOption[] = Object.values(multiMetricData).map(metricData => {
      return {
        name: metricData.name,
        type: 'bar',
        animation: true,
        coordinateSystem: 'polar',
        color: colorFn(metricData.name, sliceId),
        // @ts-ignore
        data: combineMetrics ? ([...metricData.data, metricData.total] as OptionDataValue[])
          : (metricData.data as OptionDataValue[])
      };
    });

    const echartOptions: EChartsCoreOption = {
      tooltip: {
        ...defaultTooltip,
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        }
      },
      legend: {
        show: showLegend
      },
      polar: {
          radius: [30, '80%']
      },
      angleAxis: {
          // max: Math.max(...seriesData as number[]) * 1.2,
          startAngle: 75
      },
      radiusAxis: {
          type: 'category',
          data: combineMetrics ? getSeriesKeys(keys, CONSTANTS.combinedMetricLabel) : keys
        },
      series,
    };
  
    return {
      formData,
      width,
      height,
      echartOptions,
      setDataMask,
      labelMap,
      groupby
    };
}
  